import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import {
  CommSchemeSetupCreateDto,
  CommSchemeSetupUpdateDto,
} from '@shared/data-access/dto';
import { ICommSchemeSetup } from '@shared/data-access/interfaces';
import { CommSchemeSetupModel } from '@shared/data-access/models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommSchemeSetupApiService {
  static COMM_SCHEME_SETUP = 'transaction/comm-schemes';

  constructor(private apiService: ApiService) { }

  create(data: CommSchemeSetupCreateDto): Observable<CommSchemeSetupModel> {
    return this.apiService
      .post(`${CommSchemeSetupApiService.COMM_SCHEME_SETUP}`, data)
      .pipe(map((res: ICommSchemeSetup) => CommSchemeSetupModel.fromJson(res) as CommSchemeSetupModel));
  }

  get(itemId: number): Observable<CommSchemeSetupModel> {
    return this.apiService
      .get(CommSchemeSetupApiService.COMM_SCHEME_SETUP + '/' + itemId)
      .pipe(map(res => CommSchemeSetupModel.fromJson(res) as CommSchemeSetupModel));
  }

  update(id: number, data: CommSchemeSetupUpdateDto): Observable<any> {
    return this.apiService.patch(CommSchemeSetupApiService.COMM_SCHEME_SETUP + '/' + id, data, {
      excludeFields: [''],
    });
  }

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<CommSchemeSetupModel>> {
    return this.apiService
      .get(CommSchemeSetupApiService.COMM_SCHEME_SETUP, query, option)
      .pipe(map(data => new PaginationAdapter(CommSchemeSetupModel, data)));
  }

  delete(id: number, option?: IApiOption): Observable<any> {
    return this.apiService.delete(CommSchemeSetupApiService.COMM_SCHEME_SETUP, { ids: [id] }, option);
  }

}
